import React, { useState } from 'react';
import { ShoppingCart, CheckCircle2, Download, Link2 } from 'lucide-react';
export function ProductInfo() {
  const [qty, setQty] = useState(1);
  return <div className="flex flex-col gap-4" data-id="element-474" data-mp="3qlfb60mezjck">
      {/* Purchase card (action frame) */}
      <div className="bg-brand-gray border-2 border-brand-darkGold rounded-lg p-6" data-id="element-475" data-mp="3bslre3040h23">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-6" data-id="element-476" data-mp="3gryemouw7q57">
          <div data-id="element-477" data-mp="32sf6hw230esw">
            <div className="flex items-baseline gap-3 mb-2" data-id="element-478" data-mp="32sp15wy2na4x">
              <span className="text-4xl font-bold text-brand-red" data-id="element-479" data-mp="37u4jhh8v72jm">$336.70</span>
              <span className="text-lg text-gray-400 line-through" data-id="element-480" data-mp="2swc54sf20k70">
                $612.18
              </span>
            </div>
            <div className="flex items-center gap-2 text-sm text-gray-600" data-id="element-481" data-mp="2xvor7ay3pn8j">
              <CheckCircle2 className="w-4 h-4 text-green-600" data-id="element-482" data-mp="r47hvu8i2b2m" />
              <span data-id="element-483" data-mp="r2mpaa5qx27e">
                Available: <strong className="text-brand-charcoal" data-id="element-484" data-mp="w3si07zeopgx">9</strong>
              </span>
              <span className="text-gray-300 mx-1" data-id="element-485" data-mp="wu2sysxu6vh2">|</span>
              <span data-id="element-486" data-mp="wshy127m1aio">
                Package Qty: <strong data-id="element-487" data-mp="rvj70sj8tjop">1</strong>
              </span>
            </div>
          </div>

          <div className="flex items-center gap-4" data-id="element-488" data-mp="16k5y1ri8fzvr">
            <div className="flex flex-col gap-1" data-id="element-489" data-mp="16iulb26t7hsi">
              <label htmlFor="qty" className="text-xs font-semibold text-gray-600 uppercase" data-id="element-490" data-mp="11l2vcdpq65qy">
                Qty
              </label>
              <input type="number" id="qty" min="1" value={qty} onChange={e => setQty(Math.max(1, parseInt(e.target.value) || 1))} className="w-20 border border-gray-300 rounded px-3 py-2 text-center font-semibold focus:outline-none focus:border-brand-darkGold focus:ring-1 focus:ring-brand-darkGold" data-id="element-491" data-mp="dxbfx18w1clg" />
            </div>
            <button className="bg-brand-lightGold hover:bg-brand-darkGold border border-brand-darkGold text-black font-bold px-6 py-2 rounded-md flex items-center justify-center gap-2 whitespace-nowrap transition-colors mt-5 shadow-sm" data-id="element-492" data-mp="1u96zuvwk8cs2">
              <ShoppingCart className="w-5 h-5 flex-shrink-0" data-id="element-493" data-mp="vzqkedudj761" />
              ADD TO CART
            </button>
          </div>
        </div>
      </div>

      {/* Feeds & Speeds frame (action frame) */}
      <div className="bg-white border-2 border-brand-darkGold rounded-lg p-5" data-id="element-494" data-mp="88bgigmy8hso">
        <h2 className="text-base font-bold text-brand-charcoal mb-2" data-id="element-495" data-mp="868gr4vzvaar">
          Feeds & Speeds
        </h2>
        <p className="text-gray-600 mb-3 text-sm" data-id="element-496" data-mp="d51vf0n0p7ci">
          Click on the Download link below and a PDF file will open displaying a
          printable Feeds and Speeds Chart specific for the tool selected.
        </p>
        <a href="https://www.6gtools.com/custom/uploaded/files/feedsandspeeds/Carbide_End_Mill_Feeds_and_Speeds_TuffCut_XR_177_Metric.pdf" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-brand-red hover:text-red-700 font-semibold text-sm transition-colors" data-id="element-497" data-mp="3lnhj3e0buwb9">
          <Download className="w-5 h-5 flex-shrink-0" data-id="element-498" data-mp="3d6qne2b23zwc" />
          Feeds and Speeds Download (0.13 MB)
        </a>
      </div>

      {/* Additional Links frame (action frame).
                Reserved for a future WebsiteForge rich-text field (up to three link lines).
                No placeholder content is fabricated here. */}
      <div className="bg-white border-2 border-brand-darkGold rounded-lg p-5" data-id="element-499" data-mp="2z8ai8fsuehgb">
        <h2 className="text-base font-bold text-brand-charcoal mb-3 flex items-center gap-2" data-id="element-500" data-mp="2ueemlk01x6ob">
          <Link2 className="w-4 h-4 text-brand-darkGold" data-id="element-501" data-mp="2ph66doygrcpp" />
          Additional Links
        </h2>
        <ul className="space-y-2 text-sm" data-id="element-502" data-mp="2lgm82i25m31z">
          <li data-id="element-503" data-mp="2gfor28svrf22">
            <a href="https://www.6gtools.com/20m8/end-mill/high-performance-end-mills.html" target="_blank" rel="noopener noreferrer" className="text-brand-red hover:text-red-700 font-medium transition-colors" data-id="element-504" data-mp="2gghr6qxc36b8">
              High Performance End MIlls
            </a>
          </li>
          <li data-id="element-505" data-mp="keweuyk58v1e">
            <a href="https://www.6gtools.com/technical-info/end-mills/feeds-and-speeds-calculator.html" target="_blank" rel="noopener noreferrer" className="text-brand-red hover:text-red-700 font-medium transition-colors" data-id="element-506" data-mp="kemqtginsxyc">
              End Mill Speeds And Feeds Calculator
            </a>
          </li>
          <li data-id="element-507" data-mp="q5i94lsb4iw">
            <a href="https://www.6gtools.com/milling/end-mills.html" target="_blank" rel="noopener noreferrer" className="text-brand-red hover:text-red-700 font-medium transition-colors" data-id="element-508" data-mp="mq4c53uk1j2">
              End Mills
            </a>
          </li>
        </ul>
      </div>
    </div>;
}